import { ref, computed } from 'vue';

const MIN_W = 300;
const MIN_H = 120;

export function useDraggableResizable() {
  const dx = ref(0);
  const dy = ref(0);
  const customW = ref(null);
  const customH = ref(null);
  const isDragging = ref(false);
  const isResizing = ref(false);

  const dragStyle = computed(() => ({
    transform: `translate(${dx.value}px, ${dy.value}px)`,
    transition: isDragging.value || isResizing.value ? 'none' : '',
    ...(customW.value != null ? { width: `${customW.value}px`, maxWidth: 'none' } : {}),
    ...(customH.value != null ? { height: `${customH.value}px`, maxHeight: 'none', overflowY: 'auto' } : {}),
    userSelect: isDragging.value || isResizing.value ? 'none' : '',
  }));

  function startDrag(e) {
    if (e.button !== 0) return;
    e.preventDefault();
    isDragging.value = true;
    const ox = e.clientX - dx.value;
    const oy = e.clientY - dy.value;
    const onMove = ev => {
      dx.value = ev.clientX - ox;
      dy.value = ev.clientY - oy;
    };
    const onUp = () => {
      isDragging.value = false;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }

  function startResize(e, el) {
    if (e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    isResizing.value = true;
    const rect = el.getBoundingClientRect();
    const sx = e.clientX;
    const sy = e.clientY;
    const sw = rect.width;
    const sh = rect.height;
    customW.value = sw;
    customH.value = sh;
    const onMove = ev => {
      customW.value = Math.max(MIN_W, sw + (ev.clientX - sx));
      customH.value = Math.max(MIN_H, sh + (ev.clientY - sy));
    };
    const onUp = () => {
      isResizing.value = false;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }

  function reset() {
    dx.value = 0;
    dy.value = 0;
    customW.value = null;
    customH.value = null;
    isDragging.value = false;
    isResizing.value = false;
  }

  return { dragStyle, isDragging, isResizing, startDrag, startResize, reset };
}
